<script setup lang="ts">
import ScrollBox from "@/stories/displays/ScrollBox/ScrollBox.vue";
import { ref } from "vue";

type ScrollBoxElement = {
  scrollToTop: () => void;
};

const scrollBoxRef = ref<ScrollBoxElement>();

const scrollToTop = () => {
  if (!scrollBoxRef.value) {
    return;
  }

  scrollBoxRef.value.scrollToTop();
};

defineExpose({ scrollToTop });
</script>

<template>
  <ScrollBox
    ref="scrollBoxRef"
    class="p-5 flex flex-col flex-grow overflow-auto pb-[200px] desktop:pb-[20px]"
  >
    <slot></slot>
  </ScrollBox>
</template>
